import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useLazyGetOutstandingPolicyPaymentQuery,
  useValidateOutstandingPolicyPaymentMutation
} from '../../../data/premiumsandpayments';
import { useGetPetInfoQuery } from '../../../data/policy';
import { useFetchOutstandingPayments } from '../../../hooks/useFetchOutstandingPayments';
import { useUpdateTransactionsData } from '../../../hooks/useUpdateTransactionsData';
import { setValidatedOustandingDetailsList } from '../../../store/slice/paymentSlice';
import { SLICES } from '../../../constants/slices';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';

export const useSelectPaymentPanel = () => {
  const dispatch = useDispatch();
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isV3PenTestRemediationEndpointsEnabled = cspConfiguration?.IsV3PenTestRemediationEndpointsEnabled;
  // Fetch pet details
  const { authDetails } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);
  const { auth0AccessToken } = authDetails;
  const { data: petDetails, isLoading: petDetailsLoading } = useGetPetInfoQuery(auth0AccessToken, {
    skip: !auth0AccessToken
  });

  // Fetch outstanding payment details per policy
  const [trigger, { isLoading: getOutstandingPolicyPaymentIsLoading }] = useLazyGetOutstandingPolicyPaymentQuery();
  const outsandingPaymentDetails = useFetchOutstandingPayments(
    petDetails,
    petDetailsLoading,
    trigger,
    auth0AccessToken,
    isV3PenTestRemediationEndpointsEnabled
  );

  // Validate instalments
  const [validateOutstandingPayment, { isLoading: validateOutstandingPaymentIsLoading }] =
    useValidateOutstandingPolicyPaymentMutation();
  const updatedTransactionsData = useUpdateTransactionsData(
    petDetails,
    outsandingPaymentDetails,
    validateOutstandingPayment
  );

  useEffect(() => {
    dispatch(setValidatedOustandingDetailsList({ updatedTransactionsData }));
  }, [updatedTransactionsData, dispatch]);

  return {
    petDetailsLoading,
    getOutstandingPolicyPaymentIsLoading,
    validateOutstandingPaymentIsLoading
  };
};
